<nf-table-layout
  #table
  [gridOptions]="gridOptions"
  [modules]="gridModules"
  [data]="data"
  [autoResizeGrid]="false"
  hideSearch
  hideClearAll
  hideTitle
></nf-table-layout>
